import { t } from '@lingui/core/macro';
import { NoddiSelectableBox } from 'noddi-ui-web';
import {
  CAR_WHEEL_POSITIONS,
  getTireSelectionOptions,
  getWheelPositionLabels,
  PassengerCarWheelPosition,
  TireSelection,
  toggleValue
} from './requestOfferOptions';

type Props = {
  tireSelection: TireSelection;
  onTireSelectionChange: (tireSelection: TireSelection) => void;
  customPositions: PassengerCarWheelPosition[];
  onCustomPositionsChange: (positions: PassengerCarWheelPosition[]) => void;
};

export const TireSelectionField = ({
  tireSelection,
  onTireSelectionChange,
  customPositions,
  onCustomPositionsChange
}: Props) => {
  const tireSelectionOptions = getTireSelectionOptions();
  const wheelPositionLabels = getWheelPositionLabels();

  return (
    <div className='flex flex-col gap-2'>
      <p className='font-semibold'>{t`Which tires should we replace?`}</p>
      {/* Same boxes as every other step; one choice, so picking another replaces it. */}
      <div className='flex flex-col gap-1'>
        {tireSelectionOptions.map(({ value, label }) => (
          <NoddiSelectableBox
            key={value}
            aria-pressed={tireSelection === value}
            isSelected={tireSelection === value}
            setIsSelected={() => onTireSelectionChange(value)}
          >
            {label}
          </NoddiSelectableBox>
        ))}
      </div>
      {tireSelection === 'CUSTOM' && (
        <div className='grid grid-cols-2 gap-1 motion-safe:animate-in motion-safe:duration-200 motion-safe:fade-in motion-safe:slide-in-from-top-2'>
          {CAR_WHEEL_POSITIONS.map((position) => {
            const isSelected = customPositions.includes(position);
            return (
              <NoddiSelectableBox
                key={position}
                size='small'
                aria-pressed={isSelected}
                isSelected={isSelected}
                setIsSelected={(selected) => onCustomPositionsChange(toggleValue(customPositions, position, selected))}
              >
                {wheelPositionLabels[position]}
              </NoddiSelectableBox>
            );
          })}
        </div>
      )}
    </div>
  );
};
